import { defineStore } from "pinia";
import { useApi } from "@js/api/gql";
import { mediaAssetsQuery } from "../queries";
import { useFiltersStore } from "./filters";
import { watch, toRef, ref, unref, type Ref } from "vue";
import { formatFilters } from "@/js/helpers/filters";

export const useImagesStore = defineStore("images", () => {
  const filtersStore = useFiltersStore();

  const limit = ref(24);
  const currentPage = ref(1);
  const totalPages = ref(0);
  const images: Ref<Asset[]> = ref([]);

  const imageList = useApi(
    (query: string, variables: any) => ({
      query,
      variables,
    }),
    (r: any) => r.data.data,
  );

  async function getImages() {
    // const queryFilters = formatFilters(unref(filtersStore.filters));
    // const query = createMediaAssetsQuery(filtersStore.searchQuery, filtersStore.imageType, queryFilters)
    await imageList.execute(mediaAssetsQuery, {
      search: filtersStore.searchQuery,
      folderId: filtersStore.folder,
      limit: limit.value,
      offset: (currentPage.value - 1) * limit.value,
    });
    images.value = imageList.result.value.images;
    totalPages.value = Math.ceil(imageList.result.value.total / limit.value);
  }

  watch([
    currentPage,
    () => filtersStore.searchQuery,
    () => filtersStore.folder,
    () => filtersStore.imageType,
    () => filtersStore.filters,
    filtersStore.filters,
  ], () => {
    getImages();
  })

  return {
    currentPage,
    totalPages,
    images,
    isLoading: imageList.isLoading,
    error: imageList.error,
    getImages,
  };
});

